/**
 * Entitlement Query Keys
 *
 * Centralized query key factory for all entitlement-related queries.
 * Covers the master list, individual master detail, and the waterfall aggregate.
 */

export const entitlementKeys = {
  /** Root key for all entitlement queries */
  all: ['entitlements'] as const,

  /** Base key for entitlement lists */
  lists: () => [...entitlementKeys.all, 'list'] as const,

  /** Entitlement masters list for a specific matter */
  forMatter: (matterId: number) =>
    [...entitlementKeys.lists(), matterId] as const,

  /** Base key for entitlement details */
  details: () => [...entitlementKeys.all, 'detail'] as const,

  /** Specific entitlement master detail */
  detail: (matterId: number, entitlementId: number) =>
    [...entitlementKeys.details(), matterId, entitlementId] as const,

  /** Waterfall calculation for a specific matter */
  waterfall: (matterId: number) =>
    [...entitlementKeys.all, 'waterfall', matterId] as const,

  /** Entitlement classes for a specific matter (list) */
  classesForMatter: (matterId: number) =>
    [...entitlementKeys.all, 'classes', matterId] as const,

  /** Sums brought into account against a beneficiary's share, for a matter */
  adjustmentsForMatter: (matterId: number) =>
    [...entitlementKeys.all, 'adjustments', matterId] as const,

  /** Specific entitlement class detail */
  classDetail: (matterId: number, entitlementClassId: number) =>
    [
      ...entitlementKeys.all,
      'classes',
      matterId,
      'detail',
      entitlementClassId
    ] as const
} as const;
